import { Box, Chip, Typography } from '@mui/material'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'

interface BulkDeleteConfirmDialogProps {
    open: boolean
    selectedCount: number
    selectedModelNames: string[]
    onConfirm: () => void
    onCancel: () => void
    isDeleting: boolean
}

export const BulkDeleteConfirmDialog: React.FC<BulkDeleteConfirmDialogProps> = ({
    open,
    selectedCount,
    selectedModelNames,
    onConfirm,
    onCancel,
    isDeleting
}) => {
    return (
        <Dialog
            open={open}
            onClose={onCancel}
            aria-labelledby="bulk-delete-dialog-title"
            aria-describedby="bulk-delete-dialog-description"
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle id="bulk-delete-dialog-title">
                WARNING: Are you sure you want to delete {selectedCount} model
                {selectedCount > 1 ? 's' : ''}?
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="bulk-delete-dialog-description">
                    The following model{selectedCount > 1 ? 's' : ''} will be permanently removed.
                    This operation is not reversible. Published models will not be affected.
                </DialogContentText>

                <Box sx={{ mt: 2, mb: 1 }}>
                    <Typography variant="subtitle2" gutterBottom>
                        Models to be deleted:
                    </Typography>
                    <Box
                        sx={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 1,
                            maxHeight: 200,
                            overflow: 'auto',
                            p: 1,
                            border: '1px solid #e0e0e0',
                            borderRadius: 1
                        }}
                    >
                        {selectedModelNames.map((modelName, index) => (
                            <Chip
                                key={index}
                                label={modelName}
                                size="small"
                                color="error"
                                variant="outlined"
                            />
                        ))}
                    </Box>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} variant="outlined" color="primary" disabled={isDeleting}>
                    Cancel
                </Button>
                <Button
                    onClick={onConfirm}
                    color="error"
                    variant="contained"
                    autoFocus
                    disabled={isDeleting}
                >
                    {isDeleting ? 'Deleting...' : 'Delete Models'}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
